jQuery(initSectionForm)

function initSectionForm($) {
  toggleFormTab($)
  toggleFormDescription($)
}

function toggleFormTab($) {
  const $companiesBtn = $("#companies-btn")
  const $careersBtn = $("#careers-btn")
  const $switchSlider = $("#switch-slider")
  const $suitableJob = $("#suitable-job")
  const $companiesFields = $("#companies-fields")
  const $careersFields = $("#careers-fields")
  const $careersTabTitle = $("#careers-tab-title")
  const $companiesTabTitle = $("#companies-tab-title")
  // CF7 radio buttons
  const $cf7Radios = $('input[name="form-type"]')

  if (!$companiesBtn.length || !$careersBtn.length || !$switchSlider.length) return

  let active = "careers"

  function onToggle(target) {
    if (target === active) return
    active = target

    $switchSlider.css("transform", target === "careers" ? "translateX(0%)" : "translateX(100%)")

    if (target === "careers") {
      // switch
      $careersBtn.addClass("text-white").removeClass("opacity-80")
      $companiesBtn.addClass("opacity-80").removeClass("text-white")
      // tabs title
      $careersTabTitle.removeClass("hidden")
      $companiesTabTitle.addClass("hidden")
      // campi
      $careersFields.removeClass("hidden")
      $companiesFields.addClass("hidden")

      $suitableJob.removeClass("hidden")
    } else {
      // switch
      $careersBtn.addClass("opacity-80").removeClass("text-white")
      $companiesBtn.addClass("text-white").removeClass("opacity-80")
      // tabs title
      $careersTabTitle.addClass("hidden")
      $companiesTabTitle.removeClass("hidden")
      // campi
      $companiesFields.removeClass("hidden")
      $careersFields.addClass("hidden")

      $suitableJob.addClass("hidden")
    }

    // propago il click ai CF7 radio buttons
    const radio = $cf7Radios.filter(function () {
      return $(this).val().toLowerCase() === target
    })

    if (radio.length) radio.trigger("click")
  }

  $companiesBtn.on("click", () => onToggle("companies"))
  $careersBtn.on("click", () => onToggle("careers"))
}

function toggleFormDescription($) {
  const $showMoreBtns = $(".show-more-btn")
  if (!$showMoreBtns.length) return

  $showMoreBtns.each(function () {
    const $btn = $(this)
    $btn.on("click", function () {
      const $card = $btn.closest(".form-card")
      const $desc = $card.find(".career-description")

      if ($desc.hasClass("expanded")) {
        $desc.removeClass("expanded")
        $desc.css("max-height", "")
        $btn.text("Show more")
      } else {
        $desc.addClass("expanded")
        $desc.css("max-height", $desc.prop("scrollHeight") + "px")
        $btn.text("Show less")
      }
    })
  })
}
